// EmployeeDashboard/Approve.js

import React, { useEffect, useState } from 'react';
import { useLocation, Routes, Route } from 'react-router-dom';
import EmployeeLayout from './Layout/EmployeeLayout';
import ConfirmationModal from './ConfirmationModal';
import axios from "axios";
import { toast, ToastContainer } from 'react-toastify';

import { useParams } from 'react-router-dom';

const apiUrl = process.env.REACT_APP_API_REST_URL;


const Approve = () => {
    const { token } = useParams();
    const roleId = sessionStorage.getItem("roleId");
    const numericRoleId = Number(roleId);

    console.log("token",token);
    console.log("roleid",roleId);


  const location = useLocation();
  const [showConfirmation, setShowConfirmation] = useState(false);

  useEffect(() => {
    if (token) {
      setShowConfirmation(true);
    } else {
      setShowConfirmation(false);
    }
  }, [token]);

  const handleConfirm = async () => {
    // Handle the confirmation action
    try {
        const res = await axios.post(`${apiUrl}/CCE/api/v1/userEngine/partnerApprovedByAdmin`,{ userId:token,adminId:numericRoleId}
        );
        console.log('reswa1', res);
        console.log('reswa2', res.data.statusMessage);
        if (res.data.statusMessage === "Success") {
          toast.success("Partner has been approved.");
        } else {
          toast.error('Failed to approve Partner!');
        }
      } catch (error) {
        console.error('API call failed:', error);
        // setSuccessMessage('Verification Failed!');
      }
    setShowConfirmation(false);
  };

  const handleClose = () => {
    // Handle the cancel action
    setShowConfirmation(false);
  };

  return (
    <>
      {/* <EmployeeLayout /> */}
      <ToastContainer
  position='bottom-right'
  autoClose={5000}
  newestOnTop={true}
  closeOnClick
  pauseOnHover
  theme='colored'
  toastStyle={{ textAlign: 'left' }}  // Set text-align left
  fontSize="10px"
/>      <ConfirmationModal
        open={showConfirmation}
        handleConfirm={handleConfirm}
        handleClose={handleClose}
         title="Confirm Approval"
        message="Proceed to approve the new partner registration?"
      />
      <Routes>
        <Route path="*" element={<EmployeeLayout/>} /> {/* Default or catch-all route */}
      </Routes>
    </>
  );
};

export default Approve;
